import React from "react";
import { useLocation } from "react-router-dom";
import { useT } from "@/i18n/I18nContext";
import { BrandLogos } from "@/components/common/BrandLogos";

export default function PageHeader({ title, subtitle, actions, testId }) {
  const t = useT();
  const isPresent = useLocation().pathname.startsWith("/present");
  return (
    <div data-testid={testId || "page-header"} className="flex flex-col sm:flex-row sm:items-start sm:justify-between mb-6 gap-3 sm:gap-4">
      <div className="flex items-center gap-4 min-w-0 flex-wrap">
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl font-semibold tracking-tight text-[#1F2937]">{typeof title === "string" ? t(title) : title}</h1>
          {subtitle && (
            <p className="mt-1 text-sm text-[#6B7280]">{typeof subtitle === "string" ? t(subtitle) : subtitle}</p>
          )}
        </div>
        {isPresent && <BrandLogos size="xl" data-testid="present-header-logos" />}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap sm:shrink-0">{actions}</div>}
    </div>
  );
}
